import { Link, useNavigate } from "react-router-dom"
import CollapseHeader from "../../../core/common/collapse-header/collapse-header"
import { all_routes } from "../../router/all_routes"
import { useMemo, useRef, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import Select from "react-select";
import { DatePicker } from "antd";
import CommonTagsInput from "../../../core/common/Taginput";
import JoditEditor from "jodit-react";

const AddProjectPage = () => {

    const [tags, setTags] = useState<string[]>([]);
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const editor = useRef(null);
    const [content, setContent] = useState("");
    const [callApiAgain, setCallApiAgain] = useState(1);
    const [error, setError] = useState("");
    const [data, setData] = useState({
        project_id: "",
        project_name: "",
        owner_name: "",
        priority: "",
        cost_center: "",
        department: "",
        attachment_file: "",
        status: ""
    });

    const navigate = useNavigate()
    const {
        data: costcenter,
        loading: costcenterLoading,
        error: costcenterError,
    } = useApi("/api/master/get-costcenter", {
        method: "GET",
        autoCall: true,
    });

    const {
        data: addprojectResponse,
        loading: addprojectDataLoading,
        error: addprojectDataError,
        callApi: addProject,
    } = useApi("/api/add-project", {
        method: "POST",
        autoCall: false,
    });

    const getInputData = (
        e: React.ChangeEvent<any>
    ) => {
        const { name, value, files } = e.target;
        if (name === "attachment_file") {
            setData({ ...data, [name]: files[0] });
        }
        else {
            setData({ ...data, [name]: value });
        }
    };

    const {
        data: department,
        loading: departmentLoading,
        error: departmentError,
    } = useApi("/api/manager/view-department", {
        method: "GET",
        autoCall: true,
    });

    const departmentData = department?.data;

    const filterData = departmentData?.filter((item: any, index: any) => {
        return item.status === "1";
    });

    const DepartmentSelectData =
        filterData?.map((item: any) => ({
            value: item.ID,
            label: `${item.department}`,
        })) || [];

    const costCenterOptions =
        costcenter?.data.map((item: any) => ({
            value: item.costcentre_code,
            label: `${item.costcentre_code} - ${item.costcentre_name}`,
        })) || [];

    const config = useMemo(
        () => ({
            readonly: false,
        }),
        []
    );

    const postData = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!content || content.replace(/<[^>]*>/g, "").trim() === "") {
            setError("Description is required");
            return;
        }
        setError("")

        const formData = new FormData();

        formData.append("project_name", data.project_name);
        formData.append("owner_name", data.owner_name);
        formData.append("description", content);
        tags.forEach((tag) => {
            formData.append("tag_name[]", tag);
        });
        formData.append(
            "start_date",
            startDate ? startDate.format("YYYY-MM-DD") : ""
        );
        formData.append("end_date", endDate ? endDate.format("YYYY-MM-DD") : "");
        formData.append("priority", data.priority);
        formData.append("cost_center_code", data.cost_center);
        formData.append("department", data.department);
        formData.append("attachment_file", data.attachment_file);

        try {
            const response = await addProject(formData);
            if (response.success) {
                Swal.fire({
                    icon: "success",
                    title: "Project Added",
                    text:
                        response?.message || "Your project has been added successfully.",
                    confirmButtonColor: "#3085d6",
                });
                document.getElementById("closed_modal")?.click();
                setCallApiAgain(callApiAgain + 1);

                setData({
                    project_id: "",
                    project_name: "",
                    owner_name: "",
                    priority: "",
                    cost_center: "",
                    department: "",
                    attachment_file: "",
                    status: ""
                });
                setTags([]);
                setStartDate(null);
                setEndDate(null);
                setContent("");
                navigate('/projects')
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Projects</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={all_routes.adminDashboard}>
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item">Employee</li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Projects
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                        {/* <div className="mb-2">
                            <Link
                                to="#"
                                data-bs-toggle="modal"
                                data-inert={true}
                                data-bs-target="#add_project"
                                className="btn btn-primary d-flex align-items-center"
                            >
                                <i className="ti ti-circle-plus me-2" />
                                Add Project
                            </Link>
                        </div> */}
                        <div className="ms-2 head-icons">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={postData}>
                            <div className="row">
                                {/* Project Name */}
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Project Name <sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Project Name"
                                            name="project_name"
                                            onChange={getInputData}
                                            value={data.project_name}
                                        />
                                    </div>
                                </div>

                                {/* Owner */}
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Owner <sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Owner Name"
                                            name="owner_name"
                                            onChange={getInputData}
                                            value={data.owner_name}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Cost Center */}
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        Cost Center <sup className="text-danger">*</sup>
                                    </label>
                                    <Select
                                        name="cost_center"
                                        options={costCenterOptions}
                                        placeholder="Select Cost Center"
                                        required
                                        onChange={(selectedOption: any) =>
                                            getInputData({
                                                target: {
                                                    name: "cost_center",
                                                    value: selectedOption?.value || "",
                                                },
                                            } as any)
                                        }
                                    />
                                </div>

                                {/* Department */}
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        Department <sup className="text-danger">*</sup>
                                    </label>
                                    <Select
                                        name="department"
                                        options={DepartmentSelectData}
                                        placeholder="Select Department"
                                        onChange={(selectedOption: any) =>
                                            getInputData({
                                                target: {
                                                    name: "department",
                                                    value: selectedOption?.value || "",
                                                },
                                            } as any)
                                        }
                                        required
                                    />
                                </div>

                                {/* Start Date */}
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        Start Date <sup className="text-danger">*</sup>
                                    </label>
                                    <DatePicker
                                        className="form-control"
                                        value={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        placeholder="DD-MM-YYYY"
                                        disabledDate={(current) =>
                                            current && current.isBefore(dayjs().startOf("day"))
                                        }
                                        required
                                    />
                                </div>

                                {/* End Date */}
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        End Date <sup className="text-danger">*</sup>
                                    </label>
                                    <DatePicker
                                        className="form-control"
                                        value={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        placeholder="DD-MM-YYYY"
                                        disabledDate={(current: any) =>
                                            current &&
                                            (current.isBefore(dayjs().startOf("day")) ||
                                                (startDate && current.isBefore(startDate)))
                                        }
                                        required
                                    />
                                </div>

                                {/* Tags */}
                                <div className="col-md-12 mb-3">
                                    <label className="form-label">
                                        Tags <sup className="text-danger">*</sup>
                                    </label>
                                    <CommonTagsInput
                                        value={tags}
                                        onChange={setTags}
                                        placeholder="Add new"
                                    />
                                    <small className="text-danger">
                                        (Press enter to add more)
                                    </small>
                                </div>

                                {/* Priority */}
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        Priority <sup className="text-danger">*</sup>
                                    </label>
                                    <select
                                        className="form-select"
                                        name="priority"
                                        onChange={getInputData}
                                        value={data.priority}
                                        required
                                    >
                                        <option value="">Select Priority</option>
                                        <option value="High">High</option>
                                        <option value="Medium">Medium</option>
                                        <option value="Low">Low</option>
                                    </select>
                                </div>

                                {/* File Upload */}
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Upload File</label>
                                    <input
                                        className="form-control"
                                        type="file"
                                        name="attachment_file"
                                        onChange={getInputData}
                                    />
                                </div>

                                {/* Description */}
                                <div className="col-md-12 mb-3">
                                    <label className="form-label">
                                        Description <sup className="text-danger">*</sup>
                                    </label>
                                    <JoditEditor
                                        ref={editor}
                                        value={content}
                                        config={config}
                                        onBlur={(newContent) => setContent(newContent)}
                                    />
                                    {error && <small className="text-danger">{error}</small>}
                                </div>

                                {/* Actions */}
                                <div className="col-md-12 d-flex justify-content-end mt-3">
                                    <button className="btn btn-outline-secondary me-2"
                                        onClick={() => navigate("/projects")}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Add Project
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AddProjectPage